export default __webpack_public_path__ + "static/media/logo.0791b2a9.svg";